import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { SharedService } from './../services/shared.service';
import { ToastService } from '../services/toast.service';
import { ToastType } from '../enums/enums';

@Injectable()
export class AppInterceptor implements HttpInterceptor {
  constructor(private sharedService: SharedService, private toastService: ToastService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this.sharedService.getData('token');

    const req = request.clone({
      headers: request.headers.set('Authorization', authToken ? 'Bearer ' + JSON.parse(authToken) : '')
    });

    return next.handle(req).pipe(
      tap({
        next: (event: any) => {
          if (event instanceof HttpResponse) {
            if (event.status >= 200 && event.status <= 230) {
              return event;
            } else {
              this.toastService.showToast({
                message: event.body.message,
                type: ToastType.Warning
              });
            }
          }
          return null;
        },
        error: (error) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 401) {
              this.sharedService.setUserLoggedIn(false);
            }
            if (error.error) {
              this.toastService.showToast({
                message: error.error.message || error.message || error.statusText,
                type: ToastType.Error
              });
            }
          }
        }
      })
    );
  }
}
